module.exports = __webpack_public_path__ + "static/media/hund-han.a2b77c23.svg";